import loadable from '@loadable/component';

export const FixedStaffToolsLoadable = loadable(
  () => import('./FixedStaffTools'),
  { resolveComponent: (module) => module.FixedStaffTools },
);
